// src/pages/RegisterSuccessful.tsx
import RegistrationSuccess from "../../components/Hackathons/RegistrationSuccess";

export default function RegisterSuccessfulPage() {
  return <RegistrationSuccess />;
}